import { render, staticRenderFns } from "./ManualCliente.vue?vue&type=template&id=121c8afd&"
import script from "./ManualCliente.vue?vue&type=script&lang=js&"
export * from "./ManualCliente.vue?vue&type=script&lang=js&"
import style0 from "./ManualCliente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports